import {FC} from 'react'

type PropsImg = {
  field: string,
  value: string,
}

const ImgForm: FC<PropsImg> = ({field, value}) => (

  <>
    <div className='row mb-7'>
      <label className='col-lg-4 fw-bold text-muted text-capitalize'>{field}</label>
      <div className='col-lg-8 fv-row'>
        <img src={value} alt="" className="w-75 border border-1"/>
      </div>
    </div>
  </>
)

export {ImgForm}